export default {"src":"/_next/static/media/download-icon.ff14d956.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};